export const COLORS = {
  blue: "#3875BF",
  black: "#000000",
  white: "#FFFFFF",
  darkestGrey: "#333333",
  darkerGrey: "#403f3d",
  darkGrey: "#666666",
  themeGreen: "#69ffb4",
  grey: "#868794",
  lightGrey: "#CCCCCC",
  lighterGrey: "#EEEEEE",
  red: "#F40D0D",
  darkRed: "#8B0000",
  purple: "#C82A89",
  lightBlue: "#2BDBDB",
  darkBlue: "#212AAC",
  vividBlue: "#6bccf9",
  orange: "#E0920B",
  green: "#2BDB77",
  yellow: "#EFF710",
  papayaWhip: "#FFEFD5",
  googleRed: "#DB4437",
  facebookBlue: "#3b5998",
  backgroundGreen: "#BFE2B3",
  textGreen: "#005a00",
  backgroundRed: "#e59797",
  textRed: "#8B0000",
  backgroundYellow: "#eae5ab",
  textYellow: "#6d671d",
  backgroundBlue: "#9cb9d8",
  textBlue: "#0c2642",
  gold: "#FFBF00",
  pink: "#FF69B4",
  magenta: "#e90076",
  main: "#5ea3d0",
  lightPurple: "#D8BFD8",
  deepPurple: "#8A2BE2",
  brown: "#7B3F00",
};
